import { QarepaEnumInformation } from '@qarepa/common';

export enum HolidayTypeEnum {
  NATIONAL = 'NATIONAL',
  REGIONAL = 'REGIONAL',
  LOCAL = 'LOCAL',
  INTERNAL = 'INTERNAL',
}

export type HolidayTypeType =
  | HolidayTypeEnum.NATIONAL
  | HolidayTypeEnum.REGIONAL
  | HolidayTypeEnum.LOCAL
  | HolidayTypeEnum.INTERNAL;

export const HolidayTypeArray = [
  HolidayTypeEnum.NATIONAL,
  HolidayTypeEnum.REGIONAL,
  HolidayTypeEnum.LOCAL,
  HolidayTypeEnum.INTERNAL,
];

export const HolidayTypeInfo: QarepaEnumInformation<HolidayTypeEnum> = {
  [HolidayTypeEnum.NATIONAL]: {
    name: $localize`Nacional`,
  },
  [HolidayTypeEnum.REGIONAL]: {
    name: $localize`Regional`,
  },
  [HolidayTypeEnum.LOCAL]: {
    name: $localize`Local`,
  },
  [HolidayTypeEnum.INTERNAL]: {
    name: $localize`Interno`,
  },
};
